var styleDataHash = "154c91df";
const injectCss = () => {
  var css = `@charset "UTF-8";.M02ip,.ReactModalPortal,.glob_fontElementMap,.nLt4w,button{font-family:var(--ricos-font-family,unset)}.kElZm{display:flex}[dir] .QdAAz:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] .QdAAz:hover,[dir] .b8mUe{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}[dir] .b8mUe{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] .bl5rQ .b8mUe{box-shadow:none!important}.ZoBG7{display:block;height:100%;position:absolute;top:0;width:100%}[dir] .ZoBG7{cursor:move}[dir=ltr] .ZoBG7{left:0}[dir=rtl] .ZoBG7{right:0}.ZoBG7.m1bCT{pointer-events:none}[dir] ._0QhOc ::selection{background:transparent}.Eb01N{display:none}.M02ip{position:relative}._1784W{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{font-weight:300}[dir=ltr] .ReactModal__Content{direction:ltr}[dir=rtl] .ReactModal__Content{direction:rtl}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}.gVQh7{color:#333;text-decoration:none}.riYM7{display:block}.a6xAt{position:relative}.VkGHb{overflow-x:auto;overflow-y:hidden}[dir=ltr] .VkGHb,[dir=rtl] .VkGHb{margin-left:-20px;margin-right:-20px}[dir] .VkGHb.ekdto::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}[dir] .VkGHb.dRFr3::-webkit-scrollbar-thumb{background-color:transparent}.ZOgb9{max-width:max-content!important;min-width:100%}.VkGHb::-webkit-scrollbar{-webkit-appearance:none}[dir] .VkGHb::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.VkGHb::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_default = {
  "fontElementMap": "nLt4w",
  "pluginContainer": "M02ip",
  "flex": "kElZm",
  "isFocusable": "QdAAz",
  "hasFocus": "b8mUe",
  "dragImageView": "bl5rQ",
  "overlay": "ZoBG7",
  "noPointerEventsOnFocus": "m1bCT",
  "hideTextSelection": "_0QhOc",
  "hidden": "Eb01N",
  "pluginContainerMobile": "_1784W",
  "isImage": "gVQh7",
  "anchor": "riYM7",
  "horizontalScrollbarWrapper": "a6xAt",
  "pluginWithHorizontalScrollbar": "VkGHb",
  "show": "ekdto",
  "hide": "dRFr3",
  "horizontalScrollbar": "ZOgb9"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
